export default function PHP_sinh() {
  return (
    <div>
      <h1>PHP_sinh</h1>
    </div>
  );
}
